import PARENT from '../types';

const NULL_VALUE = `${PARENT}/NULL_VALUE`;

export const SET_NULL_VALUE = `${NULL_VALUE}/SET`;

export default NULL_VALUE;
